import { parseTime, toTimestamp } from "@/common/utils/Date.js";
export default {
  data() {
    return {
      point: 0, //剩余总积分
      checkCount: 0, //连续签到天数
      checkDate: 0, //签到日期
      diffDay: 1, //签到间隔时间
    };
  },
  created() {
    this._getUserIntegralInfo();
    this._getUserCheckInfo();
  },
  methods: {
    _getUserIntegralInfo() {
      //获取用户签到积分
      // "integral": 积分余额, "lateTime": "最近领取时间", "userTime": "使用时间",
      // "usedIntegral": "已用积分", "totalIntegral": "总积分",
      this.$api.post(
        this.$urls.SIGN.getUserIntegral,
        {},
        (resp) => {
          if (resp.data.code === 200) this.point = resp.data.data.integral;
        },
        (err) => {
          reject(err.message);
        }
      );
    },

    _getUserCheckInfo() {
      //获取用户签到数
      // "checkDate": "签到日期",          "createTime": "创建时间",
      // "checkCount": "连续第几天签到",         "totalCheckCount": "总签到次数",
      // "loopCheckCount": "连续第几天签到，循环计算，eg:连续7天送，7天一到重新计算",
      this.$api.post(
        this.$urls.SIGN.getUserCheckInfo,
        {},
        (resp) => {
          if (resp.data.code === 200) {
            this.checkCount = resp.data.data.checkCount;
            this.checkDate = toTimestamp(resp.data.data.checkDate, 8);
            const todayDate = toTimestamp(
              parseTime(new Date(), "{y}-{m}-{d}", 8),
              8
            );
            this.diffDay = (todayDate - this.checkDate) / (1000 * 24 * 60 * 60);
            if (this.diffDay >= 2) this.checkCount = 0;
          }
        },
        (err) => {
          reject(err.message);
        }
      );
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/sign/mixins/userSignInfo.js